import AutoCompleteFilter from '../../../../../components/AutoCompleteFilter'
import baseService from '../../../../../services/baseService'

export const inputsFiltersBrands = ({
  localFilterValues,
  handleFilterChange,
}) => [
  {
    label: 'Nome',
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="name"
        model="brand"
        value={localFilterValues.name}
        onChange={(selected) => handleFilterChange('name', selected)}
        placeholder="Filtre as marcas pelo nome"
        isMulti
        isClearable
      />
    ),
  },
]
